import { TopRightMenu } from '../NavMenus/TopNavigation';
import Logo from '../Common/Logo';
import useScrollWindow from '@/hooks/useScrollWindow';

const HERO_IMAGE_SRC = '/static/images/KeyVisuals/hero.png';

export default function Header({
  children: heroContent,
  showNavbar = true,
}: {
  children?: React.ReactNode;
  showNavbar?: boolean;
}) {
  const { scrolled, isMobile } = useScrollWindow();

  return (
    <section className="home-header">
      {!isMobile && (
        <div className="hero-static-image-container">
          <img src={HERO_IMAGE_SRC} alt="" className="hero-static-image" />
          <div className="hero-video-overlay" aria-hidden />
        </div>
      )}
      <div className="background-image-container">
        <img src={HERO_IMAGE_SRC} alt="" style={{ height: '90vh', paddingBottom: '30px' }} />
        <div className="hero-video-overlay" aria-hidden />
      </div>

      <div className="overlay-content home-hero-overlay">
        {showNavbar && (
          <div
            className={`header-content site-header home-header-bar ${scrolled ? 'header-gradient home-header-bar-scrolled' : ''}`}
            style={{
              position: 'fixed',
              top: '0',
              left: '0',
              width: '100%',
              zIndex: '1000',
              backgroundColor: scrolled ? '#ffffff' : 'rgba(255, 255, 255, 0.52)',
            }}
          >
            <Logo />
            <TopRightMenu renderizedBy="ApplyPage" />
          </div>
        )}
        {heroContent != null ? (
          <div className="home-hero-content">{heroContent}</div>
        ) : (
          <h1 className="custom-slogan gradient-color text-center">DATA FOR TOMORROW'S HEALTH</h1>
        )}
      </div>
    </section>
  );
}
